import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { FormGroup, ReactiveFormsModule } from '@angular/forms'
import { PeriodForm } from '@features/insured/models/period/period.model'
import { CommonModule } from '@angular/common'
import { AlbertSelectComponent } from '@shared/components/albert-select/albert-select.component'
import { InsuredBaseForm } from '../insured-base-form.directive'

@Component({
  selector: 'albert-period',
  imports: [ReactiveFormsModule, CommonModule, AlbertSelectComponent],
  templateUrl: './period.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class PeriodComponent extends InsuredBaseForm<PeriodForm> {
  public override readonly form = input.required<FormGroup<PeriodForm>>()
  public readonly periodOptions = input<{ label: string; value: string }[]>()

  protected override getFormGroup(): FormGroup<PeriodForm> {
    return this.form()
  }
}
